// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.botImg{
  -webkit-animation-name: fadeinWithSizeInc; 
  -webkit-animation-duration: 2s;/* Safari, Chrome and Opera > 12.1 */ /* Firefox < 16 */ /* Internet Explorer */ /* Opera < 12.1 */
 animation: fadeinWithSizeInc 2s;
}

@keyframes fadeinWithSizeInc {
  from { opacity: 0.4;height: 3vw; width: 3vw; position: fixed; left: 8vw; bottom: 12vh;}
  to   { opacity: 1;height: 100vh; width: 100vw; position: fixed; left: 0; bottom: 0; }
}

.botVideo{
  -webkit-animation-name: fadeinWithSizeDec; 
  -webkit-animation-duration: 2s;/* Safari, Chrome and Opera > 12.1 */ /* Firefox < 16 */ /* Internet Explorer */ /* Opera < 12.1 */
 animation: fadeinWithSizeDec 2s;
}

@keyframes fadeinWithSizeDec {
  from   { opacity: 1;height: 100vh; width: 100vw; position: fixed; left: 8vw; bottom: 12vh;}
  to { opacity: 0.4;height: 3vw; width: 3vw; position: fixed; left: 8vw; bottom: 12vh;}
}

.stage {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 18px 18px;
  width: 60px;
  background: #dfdfdf;
  margin: 10px 10px 10px 0;
  border-radius: 16px 16px 16px 0;
  overflow: hidden;
}

.dot-pulse {
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #333;
  color: #333;
  box-shadow: 9999px 0 0 -5px #333;
  animation: dotPulse 1.5s infinite linear;
  animation-delay: .25s;
}

.dot-pulse::before, .dot-pulse::after {
  content: '';
  display: inline-block;
  position: absolute;
  top: 0;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #333;
  color: #333;
}

.dot-pulse::before {
  box-shadow: 9984px 0 0 -5px #333;
  animation: dotPulseBefore 1.5s infinite linear;
  animation-delay: 0s;
}

.dot-pulse::after {
  box-shadow: 10014px 0 0 -5px #333;
  animation: dotPulseAfter 1.5s infinite linear;
  animation-delay: .5s;
}

@keyframes dotPulseBefore {
  0% {
    box-shadow: 9984px 0 0 -5px #333;
  }
  30% {
    box-shadow: 9984px 0 0 2px #333;
  }
  60%,
  100% {
    box-shadow: 9984px 0 0 -5px #333;
  }
}

@keyframes dotPulse {
  0% {
    box-shadow: 9999px 0 0 -5px #333;
  }
  30% {
    box-shadow: 9999px 0 0 2px #333;
  }
  60%,
  100% {
    box-shadow: 9999px 0 0 -5px #333;
  }
}

@keyframes dotPulseAfter {
  0% {
    box-shadow: 10014px 0 0 -5px #333;
  }
  30% {
    box-shadow: 10014px 0 0 2px #333;
  }
  60%,
  100% {
    box-shadow: 10014px 0 0 -5px #333;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/chatboxpage.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,8BAA8B,CAAC,oCAAoC,EAC9B,iBAAiB,EACjB,sBAAsB,EACtB,iBAAiB;CAClD,+BAA+B;AACrC;;AAEA;EACE,OAAO,YAAY,CAAC,WAAW,EAAE,UAAU,EAAE,eAAe,EAAE,SAAS,EAAE,YAAY,CAAC;EACtF,OAAO,UAAU,CAAC,aAAa,EAAE,YAAY,EAAE,eAAe,EAAE,OAAO,EAAE,SAAS,EAAE;AACtF;;AAMA;EACE,yCAAyC;EACzC,8BAA8B,CAAC,oCAAoC,EAC9B,iBAAiB,EACjB,sBAAsB,EACtB,iBAAiB;CAClD,+BAA+B;AACrC;;AAOA;EACE,SAAS,UAAU,CAAC,aAAa,EAAE,YAAY,EAAE,eAAe,EAAE,SAAS,EAAE,YAAY,CAAC;EAC1F,KAAK,YAAY,CAAC,WAAW,EAAE,UAAU,EAAE,eAAe,EAAE,SAAS,EAAE,YAAY,CAAC;AACtF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,gCAAgC;EAChC,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;AACF","sourcesContent":[".botImg{\r\n  -webkit-animation-name: fadeinWithSizeInc; \r\n  -webkit-animation-duration: 2s;/* Safari, Chrome and Opera > 12.1 */\r\n -moz-animation: fadeinWithSizeInc 2s; /* Firefox < 16 */\r\n  -ms-animation: fadeinWithSizeInc 2s; /* Internet Explorer */\r\n   -o-animation: fadeinWithSizeInc 2s; /* Opera < 12.1 */\r\n      animation: fadeinWithSizeInc 2s;\r\n}\r\n\r\n@keyframes fadeinWithSizeInc {\r\n  from { opacity: 0.4;height: 3vw; width: 3vw; position: fixed; left: 8vw; bottom: 12vh;}\r\n  to   { opacity: 1;height: 100vh; width: 100vw; position: fixed; left: 0; bottom: 0; }\r\n}\r\n@-webkit-keyframes fadeinWithSizeInc {\r\n  from { opacity: 0.4;height: 3vw; width: 3vw; position: fixed; left: 8vw; bottom: 12vh;}\r\n  to   { opacity: 1;height: 100vh; width: 100vw; position: fixed; left: 0; bottom: 0; }\r\n}\r\n\r\n.botVideo{\r\n  -webkit-animation-name: fadeinWithSizeDec; \r\n  -webkit-animation-duration: 2s;/* Safari, Chrome and Opera > 12.1 */\r\n -moz-animation: fadeinWithSizeDec 2s; /* Firefox < 16 */\r\n  -ms-animation: fadeinWithSizeDec 2s; /* Internet Explorer */\r\n   -o-animation: fadeinWithSizeDec 2s; /* Opera < 12.1 */\r\n      animation: fadeinWithSizeDec 2s;\r\n}\r\n\r\n@-webkit-keyframes fadeinWithSizeDec {\r\n  from   { opacity: 1;height: 100vh; width: 100vw; position: fixed; left: 8vw; bottom: 12vh;}\r\n  to { opacity: 0.4;height: 3vw; width: 3vw; position: fixed; left: 8vw; bottom: 12vh;}\r\n}\r\n\r\n@keyframes fadeinWithSizeDec {\r\n  from   { opacity: 1;height: 100vh; width: 100vw; position: fixed; left: 8vw; bottom: 12vh;}\r\n  to { opacity: 0.4;height: 3vw; width: 3vw; position: fixed; left: 8vw; bottom: 12vh;}\r\n}\r\n\r\n.stage {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: relative;\r\n  padding: 18px 18px;\r\n  width: 60px;\r\n  background: #dfdfdf;\r\n  margin: 10px 10px 10px 0;\r\n  border-radius: 16px 16px 16px 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.dot-pulse {\r\n  position: relative;\r\n  left: -9999px;\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 5px;\r\n  background-color: #333;\r\n  color: #333;\r\n  box-shadow: 9999px 0 0 -5px #333;\r\n  animation: dotPulse 1.5s infinite linear;\r\n  animation-delay: .25s;\r\n}\r\n\r\n.dot-pulse::before, .dot-pulse::after {\r\n  content: '';\r\n  display: inline-block;\r\n  position: absolute;\r\n  top: 0;\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 5px;\r\n  background-color: #333;\r\n  color: #333;\r\n}\r\n\r\n.dot-pulse::before {\r\n  box-shadow: 9984px 0 0 -5px #333;\r\n  animation: dotPulseBefore 1.5s infinite linear;\r\n  animation-delay: 0s;\r\n}\r\n\r\n.dot-pulse::after {\r\n  box-shadow: 10014px 0 0 -5px #333;\r\n  animation: dotPulseAfter 1.5s infinite linear;\r\n  animation-delay: .5s;\r\n}\r\n\r\n@keyframes dotPulseBefore {\r\n  0% {\r\n    box-shadow: 9984px 0 0 -5px #333;\r\n  }\r\n  30% {\r\n    box-shadow: 9984px 0 0 2px #333;\r\n  }\r\n  60%,\r\n  100% {\r\n    box-shadow: 9984px 0 0 -5px #333;\r\n  }\r\n}\r\n\r\n@keyframes dotPulse {\r\n  0% {\r\n    box-shadow: 9999px 0 0 -5px #333;\r\n  }\r\n  30% {\r\n    box-shadow: 9999px 0 0 2px #333;\r\n  }\r\n  60%,\r\n  100% {\r\n    box-shadow: 9999px 0 0 -5px #333;\r\n  }\r\n}\r\n\r\n@keyframes dotPulseAfter {\r\n  0% {\r\n    box-shadow: 10014px 0 0 -5px #333;\r\n  }\r\n  30% {\r\n    box-shadow: 10014px 0 0 2px #333;\r\n  }\r\n  60%,\r\n  100% {\r\n    box-shadow: 10014px 0 0 -5px #333;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
